<template>
  <section class="ai-card" :class="['ai-card-' + card.type, { 'ai-card-text': !known, 'ai-card-fallback': !known, 'ai-card-execution': card.type === 'action_list' && card.executionMode === 'explicit' }]">
    <ai-compatibility-notice :state="support" :paused="compatibilityPaused">
      <template v-if="known">
        <component :is="renderer" :card="card" :blocked="blocked" :busy="busy" :action-busy="actionBusy" :pagination="pagination" :read-only="readOnly" :now="now"
          @action="$emit('action', $event)" @page="$emit('page', $event)" />
        <div v-if="card.type === 'action_list' || (card.interaction && !readOnly)" class="ai-cancel-slot"><button v-if="card.interaction && !readOnly" :disabled="disabled" class="ai-link ai-cancel" @click="send('cancel', {})">{{ card.type === 'action_list' ? '取消本次操作' : '取消' }}</button></div>
        <ai-compatibility-notice v-if="expired && !readOnly" message="本次操作已过期，请重新发起。" />
      </template>
    </ai-compatibility-notice>
  </section>
</template>
<script>
import behavior from '@/ai/components/mixins/card-behavior'
import registry from './registry'
import AiCompatibilityNotice from './AiCompatibilityNotice.vue'
import { componentSupport } from '@/ai/protocol/component-support'
export default {
  mixins: [behavior],
  components: { AiCompatibilityNotice },
  computed: {
    renderer() { return registry[this.card.type] },
    support() { return componentSupport(this.card) },
    // 只在导致阻断的组件处说明；历史只读不等于本轮暂停，未知可选项不误报。
    compatibilityPaused() {
      return this.support === 'unsupported' && this.blocked && !this.readOnly &&
        (this.card.required === true)
    }
  }
}
</script>
<style scoped src="./cards.css"></style>

<style scoped>
.ai-card-action_list { overflow-anchor:none; }
.ai-card-action_list .ai-cancel-slot { height:42px;display:flex;align-items:flex-end;justify-content:flex-end; }
.ai-card-action_list .ai-cancel { margin:0;height:34px;box-sizing:border-box; }
/* Unknown components use ordinary text presentation; protocol blocking stays unchanged. */
.ai-card-fallback ::v-deep .ai-compatibility-message { text-align: left; }
</style>
